import type { ReactNode } from "react";
import EpcLoginScene from "../../components/auth/EpcLoginScene";

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen overflow-hidden" style={{ backgroundColor: '#F2EADB' }}>
      {/* Scene runs full-bleed edge to edge; its slice crop keeps the world
          covering any viewport size without letterboxing */}
      <div className="absolute inset-0 overflow-hidden">
        <EpcLoginScene className="absolute inset-0" />
      </div>

      {/* Auth card floats over the scene — right side on desktop, centred on small screens */}
      <div className="relative z-10 flex min-h-screen w-full items-center justify-center px-6 py-12 lg:justify-end lg:pr-[7vw]">
        {children}
      </div>
    </div>
  );
}
